import * as PIXI from "pixi.js";

export class VisibilityManager extends PIXI.utils.EventEmitter {

    private static _instance: VisibilityManager;

    public static get instance() {
        return this._instance || (this._instance = new VisibilityManager());
    }

    private _isVisible: boolean = true;

    constructor() {
        super();

        let visibilityChange: string | undefined;

        if (typeof document.hidden !== "undefined") {
            visibilityChange = "visibilitychange";
        } else if (typeof (document as any).webkitHidden !== "undefined") {
            visibilityChange = "webkitvisibilitychange";
        } else if (typeof (document as any).mozHidden !== "undefined") {
            visibilityChange = "mozvisibilitychange";
        } else if (typeof (document as any).msHidden !== "undefined") {
            visibilityChange = "msvisibilitychange";
        }

        const onChange = (event: Event) => {
            this.handleVisibilityChange(event);
        };
        const onClick = (event: Event) => {
            if ((document.hasFocus !== undefined) && !document.hasFocus()) {
                this.handleVisibilityChange(event);
            }
        };

        if (visibilityChange) {
            document.addEventListener(visibilityChange, onChange, false);
        }

        window.onblur = onChange;
        window.onfocus = onChange;

        window.onpagehide = onChange;
        window.onpageshow = onChange;

        window.addEventListener("click", onClick);
    }

    public onChange<T>(listener: (this: T, visible: boolean) => void, context?: T): void {
        this.on("change", listener, context);
    }

    public offChange<T>(listener?: (this: T, visible: boolean) => void, context?: T): void {
        if (listener) {
            this.off("change", listener, context);
        } else {
            this.off("change");
        }
    }

    get isVisible(): boolean {
        return this._isVisible;
    }

    get isHidden(): boolean {
        return !this._isVisible;
    }

    private handleVisibilityChange(event: Event): void {
        switch (event.type) {

            case "blur":
            case "pagehide":
                if (this._isVisible) {
                    this._isVisible = false;
                    this.emit("change", false);
                }
                break;

            case "click":
            case "focus":
            case "pageshow":
                if (!this._isVisible) {
                    this._isVisible = true;
                    this.emit("change", true);
                }
                break;
        }
    }
}
